import React from 'react'
import SlrBookingInputFields from './SlrBookingInputFieldsContainer'
import SlrBookingMenu from '../SlrBookingMenu'

const SlrBookingInputs = ({ isEditMode = false }) => {
	return (
		<>
			{!isEditMode && <SlrBookingMenu />}
			<SlrBookingInputFields isSlrView={true} isEditMode={isEditMode} />
		</>
	)
}

export default SlrBookingInputs
